<template>
  <div>
    <header>
      <div class="mobile-fix-option"></div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="main-menu py-4 py-sm-0">
              <div class="menu-left">
                <div class="navbar">
                  <a @click="left_sidebar">
                    <div class="bar-style">
                      <i class="fa fa-bars sidebar-bar" aria-hidden="true"></i>
                    </div>
                  </a>
                  <LeftSidebar :leftSidebarVal="leftSidebarVal" @closeVal="closeBarValFromChild" />
                </div>
                <div class="brand-logo">
                  <router-link :to="{ path: '/shop'}">
                    <img :src='"@/assets/images/froot_logo.jpg"' class="unibud-black" alt="logo" />
                  </router-link>
                </div>
              </div>

              <div class="menu-right pull-right">
                <HeaderShop/>
                <template v-if="getEnvironment === 'BETA'">
                  <div v-if="!signedIn">
                    <router-link to="/login" class="registerLink loginLink">Sign In<br>*BETA*</router-link> <br>
                  </div>
                  <span class="registerLink loginLink" v-else>{{firstName}}<br>{{lastName}} *BETA*</span>
                </template>
                <template v-else>
                  <div v-if="!signedIn">
                    <router-link to="/login" class="registerLink loginLink">Sign In</router-link> <br>
                  </div>
                  <span class="registerLink loginLink" v-else>{{firstName}}<br>{{lastName}}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import LeftSidebar from '../widgets/left-sidebar'
import HeaderShop from '../widgets/header-shop'
import {mapGetters} from "vuex";
export default {
  data() {
    return {
      leftSidebarVal: false
    }
  },
  components: {
    LeftSidebar,
    HeaderShop
  },
  computed: {
    ...mapGetters({
      signedIn:'auth/signedIn',
      signedInName: 'auth/getFullName',
      firstName: 'auth/getFirstName',
      lastName: 'auth/getLastName',
      getEnvironment: 'cart/getEnvironment',
    })
  },
  methods: {
    left_sidebar() {
      this.leftSidebarVal = true
    },
    closeBarValFromChild(val) {
      this.leftSidebarVal = val
    }
  }
}
</script>
